import { render } from "./EditIcon.vue?vue&type=template&id=6a267c2e"
const script = {}
script.render = render

export default script